import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Register() {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    blueprint: false,
  });
  const [blueprintPassword, setBlueprintPassword] = useState('');
  const [showBlueprintPassword, setShowBlueprintPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleBlueprintChange = (e) => {
    if (e.target.checked) {
      setShowBlueprintPassword(true);
    } else {
      setShowBlueprintPassword(false);
      setBlueprintPassword('');
      setFormData({
        ...formData,
        blueprint: false,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validate blueprint password if blueprint is checked
    if (showBlueprintPassword && blueprintPassword !== 'Passw0rd$') {
      setError('Invalid blueprint password');
      setLoading(false);
      return;
    }

    // Set blueprint to true only if password is correct
    const submitData = {
      ...formData,
      blueprint: showBlueprintPassword && blueprintPassword === 'Passw0rd$',
    };

    const result = await register(submitData);

    if (!result.success) {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="container" style={{ maxWidth: '400px', marginTop: '50px' }}>
      <div className="card" style={{ padding: '30px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img
            src="https://www.point-of-rental.com/wp-content/uploads/2014/12/por-vert-e1449871819410.jpg"
            alt="Point of Rental"
            style={{ height: '60px', marginBottom: '20px' }}
          />
          <h2 style={{ margin: '0' }}>Point of Rental Data Portal</h2>
          <p style={{ color: '#666', fontSize: '14px', margin: '5px 0 0 0' }}>
            Create your account
          </p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              type="text"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">First Name</label>
            <input
              type="text"
              name="first_name"
              className="form-control"
              value={formData.first_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Last Name</label>
            <input
              type="text"
              name="last_name"
              className="form-control"
              value={formData.last_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <input
                type="checkbox"
                onChange={handleBlueprintChange}
                style={{ marginRight: '8px' }}
              />
              Blueprint Access
            </label>
          </div>

          {showBlueprintPassword && (
            <div className="form-group">
              <label className="form-label">Blueprint Password</label>
              <input
                type="password"
                className="form-control"
                value={blueprintPassword}
                onChange={(e) => setBlueprintPassword(e.target.value)}
                placeholder="Enter blueprint password"
                required
              />
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Creating Account...' : 'Register'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '20px' }}>
          Already have an account? <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
